module.exports = __webpack_public_path__ + "img/artboard1.e511f351.png";